import { render, staticRenderFns } from "./RecibosLista.vue?vue&type=template&id=4f475dfb"
import script from "./RecibosLista.vue?vue&type=script&lang=js"
export * from "./RecibosLista.vue?vue&type=script&lang=js"
import style0 from "./RecibosLista.vue?vue&type=style&index=0&id=4f475dfb&prod&lang=css"
import style1 from "./RecibosLista.vue?vue&type=style&index=1&id=4f475dfb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports